import { Injectable, Type } from '@angular/core';
import { DashboardPanelAlarmsComponent } from '@components/dashboard-panel-alarms/dashboard-panel-alarms.component';
import { DashboardPanelChannelGroupComponent } from '@components/dashboard-panel-channel-group/dashboard-panel-channel-group.component';
import { DashboardPanelMimicsComponent } from '@components/dashboard-panel-mimics/dashboard-panel-mimics.component';
import { DashboardPanelTrendGraphComponent } from '@components/dashboard-panel-trend-graph/dashboard-panel-trend-graph.component';
import { DashboardPanelInterface } from '@models/dashboard-panel-interface';
import { DashboardPanelParameters } from 'ops/common/models/dashboard-panel-parameters';
import { DashboardPanelType } from 'ops/common/models/dashboard-panel-type';

@Injectable({ providedIn: 'root' })
export class DashboardPanelFactoryService {
    private panelMapping: { [key: string]: Type<DashboardPanelInterface> } = {};

    constructor() {
        this.panelMapping[DashboardPanelType.ALARMS] = DashboardPanelAlarmsComponent;
        this.panelMapping[DashboardPanelType.MIMICS] = DashboardPanelMimicsComponent;
        this.panelMapping[DashboardPanelType.TREND_GRAPH] = DashboardPanelTrendGraphComponent;
        this.panelMapping[DashboardPanelType.CHANNEL_GROUP] = DashboardPanelChannelGroupComponent;
        this.panelMapping[DashboardPanelType.CUSTOM_GROUP] = DashboardPanelChannelGroupComponent;
    }

    public getPanel(params: DashboardPanelParameters): Type<DashboardPanelInterface> {
        if (params == null) {
            throw new Error(`Null parameters passed to ${DashboardPanelFactoryService.name}`);
        } else if (params.type in this.panelMapping) {
            return this.panelMapping[params.type];
        } else {
            throw new Error(`Invalid dashboard panel type: '${params.type}'`);
        }
    }
}
